var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.recipe.image
    ? _c(
        "div",
        {
          class: {
            collapsed: _vm.collapsed,
            printable: _vm.$store.state.recipe.printImage,
          },
        },
        [
          _c("img", {
            attrs: {
              alt: _vm.t("cookbook", "Recipe image"),
              src: _vm.$store.state.recipe.imageUrl,
            },
            on: {
              click: function ($event) {
                return _vm.toggleCollapsed()
              },
            },
          }),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }